export default __webpack_public_path__ + "static/media/email.1a5581e7.svg";